import { createMutationHelper } from '@utils/swr'
import { type ApplePayMerchantValidationRequest } from '../types/apiRequest'
import { type ApplePayMerchantValidationResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useMutation,
} = createMutationHelper<FortuneApis['post']['applePayMerchantValidation'], ApplePayMerchantValidationResponse, ApplePayMerchantValidationRequest>({
  client: 'fortune',
  key: '/payment/apple_pay_merchant_validation',
  fetcher: (url, { arg, client }) => client.post(url, arg),
})

export const useApiApplePayMerchantValidation = useMutation
